
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/onboarding-v2/[[...path]]",
      function () {
        return require("private-next-pages/onboarding-v2/[[...path]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/onboarding-v2/[[...path]]"])
      });
    }
  